import React from "react";
import { Quote, ShieldCheck } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const Testimonials = () => {
  const { t } = useLang();
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-16 md:py-32 relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-[400px] pointer-events-none opacity-60"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 0%, rgba(217,185,155,0.08), rgba(217,185,155,0) 70%)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-14">
          <div className="eyebrow">{t.testimonials.eyebrow}</div>
          <h2 className="mt-4 font-display font-light text-4xl md:text-5xl tracking-tight text-maif">
            {t.testimonials.title}
          </h2>
          {t.testimonials.note && (
            <div className="mt-4 inline-flex items-center gap-2 text-xs text-maif-muted">
              <ShieldCheck size={14} className="text-sand" />
              {t.testimonials.note}
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.testimonials.items.map((it, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="card-surface p-8 md:p-10 flex flex-col h-full relative"
            >
              <Quote size={28} className="text-terracotta opacity-40" aria-hidden />
              <blockquote className="mt-6 font-accent italic text-lg md:text-xl leading-relaxed text-maif">
                "{it.quote}"
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-sand-soft">
                <div className="flex items-center gap-3">
                  <span
                    aria-hidden
                    className="inline-flex h-10 w-10 items-center justify-center rounded-full bg-terracotta/10 border border-terracotta/30 font-display text-sand text-sm tracking-wider"
                  >
                    {it.initials}
                  </span>
                  <div>
                    <div className="font-display text-maif text-sm">
                      {it.role}
                    </div>
                    <div className="text-xs text-maif-muted">{it.company}</div>
                  </div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
